"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=typeof navigator<"u"&&String(navigator.userAgent)||"";exports.engineUserAgent=e;
